import { render, staticRenderFns } from "./invitations.page.vue?vue&type=template&id=6645b43a&scoped=true&"
import script from "./invitations.page.vue?vue&type=script&lang=js&"
export * from "./invitations.page.vue?vue&type=script&lang=js&"
import style0 from "./invitations.page.vue?vue&type=style&index=0&id=6645b43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645b43a",
  null
  
)

export default component.exports